import { useRecoilState } from "recoil";
import { isOpenSelectProductAtom } from "src/atoms";

// 제품선택 팝업 열기
export const useIsOpenSelectProduct = () => {
  const [isOpenSelectProduct, setIsOpenSelectProduct] = useRecoilState(
    isOpenSelectProductAtom
  );

  return { isOpenSelectProduct, setIsOpenSelectProduct };
};
